module.exports = __webpack_public_path__ + "static/media/TIME.af616733.svg";